<template>
  <div v-if="systemNotification" class="service-notification">
    <service-header :signedIn="signedInUser !== null"/>
    <section>
      <div class="service-notification-badge">お知らせ</div>
      <div class="service-notification-title">{{ systemNotification.title }}</div>
      <div class="service-notification-published-at">{{ systemNotification.publishedAt | moment('YYYY.MM.DD') }}</div>
      <div class="service-notification-thumbnail-wrapper">
        <img :src="systemNotification.thumbnail.url || require('@/assets/images/service/notification_thumbnail_default.png')">
      </div>
      <div
        v-for="item of systemNotification.systemNotificationItems"
        :key="item.id"
        class="service-notification-item-wrapper"
      >
        <div v-if="item.format == 'text'">{{ item.content }}</div>
        <img v-else-if="item.format == 'image'" :src="item.image.url || require('@/assets/images/service/notification_thumbnail_default.png')">
      </div>
    </section>
    <service-footer
      :signedIn="signedInUser !== null"
      :route="$route.name"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SystemNotification from '@/store/models/SystemNotification'

import ServiceHeader from '@/components/molecules/service/ServiceHeader.vue'
import ServiceFooter from '@/components/molecules/service/ServiceFooter.vue'

export default {
  name: 'ShowNotifications',
  components: {
    ServiceHeader,
    ServiceFooter
  },
  computed: {
    systemNotificationId: function() { return this.$route.params.id },
    systemNotification: function() { return SystemNotification.find(this.systemNotificationId) },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  methods: {
    ...mapActions({
      apiGetSystemNotification: 'entities/systemNotifications/show'
    })
  },
  created() {
    this.apiGetSystemNotification(this.systemNotificationId)
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.service-notification {
  width: 100%;
  background-color: white;

  section {
    overflow-x: auto;
    width: 320px;
    padding: 80px 0 40px 0;
    margin: 0 auto;

    @include mq(md) {
      width: 800px;
      padding: 130px 0 100px 0;
    }
  }

  &-badge {
    width: 82px;
    height: 24px;
    background-color: $service-primary-color;
    color: white;
    font-size: 13px;
    font-weight: 600;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-title {
    font-size: 26px;
    font-weight: 600;

    @include mq(sm) {
      font-size: 32px;
    }
  }

  &-badge, &-title {
    margin-bottom: 20px;
  }

  &-published-at {
    color: $service-primary-color;
    font-size: 15px;
  }

  &-thumbnail-wrapper {
    margin: 30px 0;
    width: 100%;
    text-align: center;

    img {
      width: 320px;
      height: 160px;
      object-fit: cover;
      border: 1px solid $light-border-color;

      @include mq(md) {
        width: 800px;
        height: 400px;
      }
    }
  }

  &-item-wrapper {
    font-size: 15px;
    line-height: 1.6;
    white-space: pre-wrap;
    margin-bottom: 30px;
    text-align: center;

    div {
      text-align: left;
    }

    img {
      max-width: 320px;
      object-fit: contain;
      border: 1px solid $light-border-color;

      @include mq(md) {
        max-width: 800px;
      }
    }
  }
}
</style>
